export default __webpack_public_path__ + "9435ddc4a2fe68729a011c682d0968a2.png";